module.exports = __webpack_public_path__ + "images/459ecdf905c3e58590bea48f36c1e64cretail.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/retail.png
// module id = VyaX
// module chunks = 0